const PlayerStatsOptionValues = {
  GOALS: 'goals',
  ASSISTS: 'assists',
  SHOTS: 'shots',
  CARDS: 'cards',
  INJURED: 'injured',
} as const;

export default PlayerStatsOptionValues;
